// Converts a string in 'YYYY-MM-DD' format to { year, month, day } object
// Accepts 'YYYY-MM' format and defaults day to 1

import { LocalDate } from '@sky-distribution/adapter-core-pc-rest-interfaces';

export function parseYearMonthToDateObject(value?: unknown): LocalDate | undefined {
  if (typeof value === 'string') {
    const match = value.match(/^(\d{4})-(\d{2})-?(\d{2})?$/);

    if (match) {
      const [, year, month, day] = match;

      return { year: Number(year), month: Number(month), day: day ? Number(day) : 1 };
    }
  }

  return undefined;
}
